export default [{
        path: '/sistemas/usuarios',
        name: 'sistemas-usuarios',
        component: () =>
            import ('@/views/pages/sistemas/Usuarios.vue'),
        meta: {
			title: 'i18n:sistemas.mantenimiento.usuarios.title',
            resource: 'Sistemas',
            action: 'ver-sistemas-mantenimiento-usuarios',
            pageTitle: 'Usuarios',
            breadcrumb: [{
                text: 'Administrar Usuarios',
                active: true,
            }, ],
        }
    },
    {
        path: '/sistemas/usuarios/roles',
        name: 'sistemas-usuarios-roles-crear',
        component: () =>
            import ('@/views/pages/sistemas/Roles.vue'),
        meta: {
			title: 'i18n:sistemas.mantenimiento.roles.title',
            resource: 'Sistemas',
            action: 'ver-sistemas-mantenimiento-roles',
            pageTitle: 'Roles',
            breadcrumb: [{
                text: 'Administrar Roles',
                active: true,
            }, ],
        },
    },
    {
        path: '/sistemas/empresas',
        name: 'sistemas-empresas',
        component: () =>
            import ('@/views/pages/sistemas/Empresas.vue'),
        meta: {
			title: 'i18n:sistemas.mantenimiento.empresas.title',
            pageTitle: 'Empresas',
            breadcrumb: [{
                resource: 'Sistemas',
                action: 'ver-sistemas-mantenimiento-empresas',
                text: 'Administrar Empresas',
                active: true,
            }, ],
        }
    },
    {
        path: '/sistemas/firmaElectronica',
        name: 'sistemas-mantenimiento-firma-electronica',
        component: () =>
            import ('@/views/pages/sistemas/FirmaElectronica.vue'),
        meta: {
			title: 'i18n:sistemas.mantenimiento.firma_electronica.title',
            pageTitle: 'Firma Electronica',
            breadcrumb: [{
                resource: 'Sistemas',
                action: 'ver-sistemas-mantenimiento-firma-electronica',
                text: 'Firma Electronica',
                active: true,
            }, ],
        }
    },
    {
        path: "/sistemas/dashboard/monitor-bot",
        name: "sistemas-dashboard-monitor-bot",
        component: () =>
            import("@/views/pages/sistemas/dashboard/MonitorBot.vue"),
        meta: {
            title: 'Monitor Bot',
            pageTitle: 'Dashboard',
            breadcrumb: [{
                text: 'Dashboard',
                active: true,
            },
            {
                resource: 'Sistemas',
                action: 'ver-sistemas-dashboard-monitor-bot',
                text: 'Monitor Bot',
                active: true,
            },],
        }
    },
]
